var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F3F3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1641 9.83301V22.1663H20.8307V11.8734L18.7903 9.83301H11.1641ZM10.1641 9.73301C10.1641 9.23595 10.567 8.83301 11.0641 8.83301H18.8317C19.0704 8.83301 19.2993 8.92783 19.4681 9.09661L21.5671 11.1956C21.7359 11.3644 21.8307 11.5933 21.8307 11.832V22.2663C21.8307 22.7634 21.4278 23.1663 20.9307 23.1663H11.0641C10.567 23.1663 10.1641 22.7634 10.1641 22.2663V9.73301Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6641 8.83301C18.9402 8.83301 19.1641 9.05687 19.1641 9.33301V11.4997H21.3307C21.6069 11.4997 21.8307 11.7235 21.8307 11.9997C21.8307 12.2758 21.6069 12.4997 21.3307 12.4997H19.0641C18.567 12.4997 18.1641 12.0967 18.1641 11.5997V9.33301C18.1641 9.05687 18.3879 8.83301 18.6641 8.83301Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.f1ae80cac8f15389d86fead06a2dab77.svg";
export { ForwardRef as ReactComponent };